export default "/images/f086751b7595d627aad1aea9044ab72b.avif";